import { AIReview } from "modules/aiReview";

const AIReviewPage = () => {
  return <AIReview />;
};

export default AIReviewPage;
